import { useEffect, useRef, useState } from 'react'
import { useSpeakingParticipants } from '@livekit/components-react'

import type { Participant } from 'livekit-client'

import { promoteSpeaker } from './speakerOrder'

export const useSpeakerPromotion = (participants: Participant[], visibleCount: number) => {
  const speaking = useSpeakingParticipants()

  const lastSpokeAt = useRef(new Map<string, number>())
  const [order, setOrder] = useState<string[]>([])

  useEffect(() => {
    speaking.forEach((participant) => {
      if (participant.identity) {
        lastSpokeAt.current.set(participant.identity, Date.now())
      }
    })
  }, [speaking])

  useEffect(() => {
    setOrder((current) => {
      const present = participants.map((participant) => participant.identity)
      const kept = current.filter((identity) => present.includes(identity))
      const arrived = present.filter((identity) => !kept.includes(identity))

      return kept.length === current.length && arrived.length === 0
        ? current
        : [...kept, ...arrived]
    })
  }, [participants])

  useEffect(() => {
    const speakingNow = speaking
      .map((participant) => participant.identity)
      .filter((identity): identity is string => !!identity)

    setOrder((current) => promoteSpeaker(current, visibleCount, speakingNow, lastSpokeAt.current))
  }, [speaking, visibleCount])

  const byIdentity = new Map(participants.map((participant) => [participant.identity, participant]))
  const ordered = order
    .map((identity) => byIdentity.get(identity))
    .filter((participant): participant is Participant => !!participant)

  const placed = new Set(order)

  return [...ordered, ...participants.filter((participant) => !placed.has(participant.identity))]
}
